import React, { useMemo, useState, useEffect } from "react";
import { Spin } from "antd";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../../hooks";
import { TeacherAPI } from "../../../../api";
import { RutasDidacticasWizard } from "../../../../components/Admin/RutasDidacticasComp";
import { RutasDidacticasFormSteps } from "../../../../components/Admin/RutasDidacticasComp/RutasDidacticasForm/RutasDidacticasFormSteps";
import { TeacherSalasGrid } from "../../../../components/Admin/TeacherportalCmp";
import { NEW_SALAS } from "../../../../ui/featureFlags";

import styles from "./Page_Teacher_Salas.module.scss";
import "./Page_Teacher_Salas.scss";

export function Page_Teacher_Salas() {
  const { t } = useTranslation("teachers");
  const { user, accessToken } = useAuth();

  const teacherController = useMemo(() => new TeacherAPI(), []);

  const [teacher, setTeacher] = useState(null);
  const [loading, setLoading] = useState(true);

  const [page, setPage] = useState(1);
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);

  const [showNewRouteModal, setShowNewRouteModal] = useState(false);

  useEffect(() => {
    let active = true;

    const fetchTeacherData = async () => {
      try {
        const response = await teacherController.getTeacherById(
          accessToken,
          user?.user?.teacher,
        );
        if (!active) return;
        setTeacher(response.teacher);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error al obtener datos del docente:", error);
      } finally {
        if (active) setLoading(false);
      }
    };

    if (user?.user?.teacher) fetchTeacherData();

    return () => {
      active = false;
    };
  }, [accessToken, teacherController, user]);

  const handleNewRoute = () => setShowNewRouteModal(true);

  if (loading) {
    return (
      <div className={styles.loading}>
        <Spin size="large" />
        <p style={{ marginTop: 12, color: "#6b7280" }}>
          {t("pages.loadingTeacher")}
        </p>
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <TeacherSalasGrid
        teacher={teacher}
        accessToken={accessToken}
        page={page}
        setPage={setPage}
        reload={reload}
        onReload={onReload}
        onNewRoute={handleNewRoute}
      />

      {showNewRouteModal &&
        (NEW_SALAS ? (
          <RutasDidacticasFormSteps
            accessToken={accessToken}
            teacher={teacher}
            forceCreateMode={true}
            onClose={() => setShowNewRouteModal(false)}
            onReload={onReload}
          />
        ) : (
          <RutasDidacticasWizard
            accessToken={accessToken}
            teacher={teacher}
            forceCreateMode={true}
            onClose={() => setShowNewRouteModal(false)}
            onReload={onReload}
          />
        ))}
    </div>
  );
}
